import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import type {
  BulkImportHistoryResponse,
  BulkImportHistoryItem,
  BulkImportHistoryStats,
  BulkImportHistoryFilters
} from '@/types/bulkImportHistory.types';

export const bulkImportHistoryService = {
  /**
   * Get paginated bulk import history with filters
   * Sends filters in request body using POST method
   */
  async getBulkImportHistory(filters?: BulkImportHistoryFilters): Promise<BulkImportHistoryResponse> {
    const body = filters || {};

    const response = await apiClient.post(
      API_ENDPOINTS.COURSE_ASSIGNMENTS.BULK_IMPORT_HISTORY,
      body
    );
    return response.data.data;
  },

  /**
   * Get bulk import history by ID
   */
  async getBulkImportHistoryById(id: string): Promise<BulkImportHistoryItem> {
    const response = await apiClient.get(
      `${API_ENDPOINTS.COURSE_ASSIGNMENTS.BULK_IMPORT_HISTORY}/${id}`
    );
    return response.data.data;
  },

  /**
   * Get bulk import history statistics
   */
  async getBulkImportHistoryStats(filters?: {
    imported_by?: string;
    start_date?: string;
    end_date?: string;
  }): Promise<BulkImportHistoryStats> {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }

    const response = await apiClient.get(
      `${API_ENDPOINTS.COURSE_ASSIGNMENTS.BULK_IMPORT_HISTORY}/stats?${params.toString()}`
    );
    return response.data.data;
  }
};
